<div class="tab-content">
  <div class="button-return">
    <app-button
      type="button"
      color="return"
      icon="agres-return"
      (btnClick)="goBack()"
      title="{{ 'global.back' | translate }}">
    </app-button>
  </div>

  <h3 class="field__section-title">{{ 'connections.oc.title' | translate }}</h3>

  <div class="field__info">
    <span>{{ 'connections.oc.description' | translate }}</span>
  </div>

  <div class="oc-card">
      <div class="oc-card__header">
        <img
          class="oc-card__logo"
          src="assets/images/john-deere/john-deere-operations-center-connected.svg"
          alt="John Deere Operations Center" />
        <div class="oc-card__meta">
          @if (status.connected) {
            <span class="oc-card__status oc-card__status--online">
              {{ 'data-exchange.connected' | translate }}
            </span>
        } @else if (status.pending) {
          <span class="oc-card__status oc-card__status--pending">
            {{ 'connections.oc.pending-status' | translate }}
          </span>
          } @else {
            <span class="oc-card__status oc-card__status--offline">
              {{ 'data-exchange.not-connected' | translate }}
            </span>
          }
        </div>
      </div>

      @if (status.connected) {
        <div class="oc-card__details">
          @if (status.organization) {
            <p class="oc-card__detail-item">
              <span class="oc-card__detail-label">{{ 'connections.oc.organization' | translate }}:</span>
              {{ status.organization.name }}
            </p>
          }
          @if (status.connectedAt) {
            <p class="oc-card__detail-item">
              <span class="oc-card__detail-label">{{ 'connections.oc.connected-at' | translate }}:</span>
              {{ status.connectedAt | date: 'mediumDate' }}
            </p>
          }
          @if (status.tokenExpiry) {
            <p class="oc-card__detail-item">
              <span class="oc-card__detail-label">{{ 'connections.oc.token-expiry' | translate }}:</span>
              {{ status.tokenExpiry | date: 'mediumDate' }}
            </p>
          }
        </div>

        <app-button
          title="{{ 'data-exchange.disconnect' | translate }}"
          icon="agres-close"
          color="danger"
          size="full"
          (btnClick)="disconnect()">
        </app-button>
        <app-button
          title="{{ 'global.reconnect' | translate }}"
          icon="agres-reload"
          size="full"
          (btnClick)="connect()">
        </app-button>
      } @else {
        <app-button
          title="{{ 'connections.oc.connect-button' | translate }}"
          icon="agres-plus"
          size="full"
          (btnClick)="connect()">
        </app-button>
      }
    </div>

  @if (status.pending) {
    <div class="oc-disconnect-notice">
      <span class="oc-disconnect-notice__icon">⚠</span>
      <div class="oc-disconnect-notice__body">
        <p>{{ 'connections.oc.org-approval-notice' | translate }}</p>
        <a
          [href]="OC_CONNECTIONS_URL"
          target="_blank"
          rel="noopener noreferrer"
          class="oc-disconnect-notice__link">
          {{ 'connections.oc.org-approval-link' | translate }} →
        </a>
      </div>
    </div>
  }

  @if (status.revokedAtOC) {
    <div class="oc-disconnect-notice">
      <span class="oc-disconnect-notice__icon">⚠</span>
      <div class="oc-disconnect-notice__body">
        <strong>{{ 'connections.oc.disconnect-oc-notice-title' | translate }}</strong>
        <p>{{ 'connections.oc.disconnect-oc-notice-body' | translate }}</p>
        <a
          [href]="OC_CONNECTIONS_URL"
          target="_blank"
          rel="noopener noreferrer"
          class="oc-disconnect-notice__link">
          {{ 'connections.oc.disconnect-oc-notice-link' | translate }} →
        </a>
      </div>
    </div>
  }
</div>
